'use strict';
import template from './rCambioDomicilioPCD.html';
import controller from './rCambioDomicilioPCD.controller';

const rCambioDomicilioPCDComponent = {
  bindings: {},
  controller,
  template
};

export default rCambioDomicilioPCDComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/rCambioDomicilioPCD/rCambioDomicilioPCD.component.js